import { Link } from 'react-router-dom';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { CATEGORY_ICONS, INTERNAL_COBRAND_LOGOS, INTERNAL_LOGOS_DARK, offerIcon } from '../config/catalogConfig';
import { partnerDetailPath } from '../hooks/usePreviewToken';
import { ServicePartner } from '../types';
import CobrandLogo from './CobrandLogo';

const namespace = 'OtherServices';

interface InternalServiceCardProps {
  partner: ServicePartner;
  preview?: string | null;
}

/**
 * Vlastní divize eVlastníci u předsedy jako ŘÁDEK na celou šířku (navazuje na původní layout
 * sekce): vlevo bílá část s ikonou oblasti, názvem, službami jako pilulkami a „Zjistit víc",
 * vpravo tmavý panel se šikmou hranou, logem divize (u Energetiky „eVlastníci + Veolia") a
 * claimem. Řádek na šířku nezávisí na počtu divizí – zapínání/vypínání v back-office nerozbije
 * layout (rozhodnutí Ondřeje 10/2026). Celý řádek je odkaz do detailu.
 */
export const InternalServiceCard: React.FC<InternalServiceCardProps> = ({ partner, preview = null }) => {
  const category = partner.offers[0]?.category ?? 'other';
  const logo = INTERNAL_LOGOS_DARK[partner.slug];
  const hasCobrand = Boolean(INTERNAL_COBRAND_LOGOS[partner.slug]);

  return (
    <Link to={partnerDetailPath(partner.slug, preview)} className="InternalServiceCard">
      <div className="InternalServiceCard__body">
        <div className="InternalServiceCard__head">
          <div className="InternalServiceCard__icon">
            <Icon name={CATEGORY_ICONS[category]} />
          </div>
          <Text as="h2" size="h3" color="Neutral800" className="InternalServiceCard__name">
            {partner.name}
          </Text>
        </div>

        <div className="InternalServiceCard__bottom">
          <ul className="InternalServiceCard__offers">
            {partner.offers.map((offer) => (
              <li key={offer.slug} className="InternalServiceCard__offer">
                <Icon name={offerIcon(offer)} color="Primary600" className="InternalServiceCard__offerIcon" />
                <span>{offer.title}</span>
                {offer.highlight && <span className="InternalServiceCard__offerHighlight">{offer.highlight}</span>}
              </li>
            ))}
          </ul>
          <span className="InternalServiceCard__more">
            {t('Card.more', namespace)}
            <Icon name="arrowRightSmall" />
          </span>
        </div>
      </div>

      <div className="InternalServiceCard__panel">
        {hasCobrand ? (
          <CobrandLogo partnerSlug={partner.slug} tone="dark" className="InternalServiceCard__cobrand" />
        ) : logo ? (
          <img src={logo} alt={partner.name} className="InternalServiceCard__logo" />
        ) : (
          <Text as="span" size="h3" color="Neutral100">
            {partner.name}
          </Text>
        )}
        <Text as="p" size="body-small" className="InternalServiceCard__claim">
          {partner.claim}
        </Text>
      </div>
    </Link>
  );
};

export default InternalServiceCard;
